import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RouterLink from 'react-router/lib/Link';

import connectUI from '../../basics/ui/UIConnector';
import suitcss from '../../../helpers/suitcss';
import { getPaymentFeeDuration } from '../../../helpers/entity';
import { shape as tariffShape } from '../../../propTypes/tariff';
import Headline from '../../basics/text/TextHeadline';
import Link from '../../basics/text/TextLink';
import Unit from '../../basics/text/TextUnit';
import Callout from '../../../containers/callout/Callout';
import FootnoteReference from '../../../containers/footnote/FootnoteReference';

class TariffItemCompact extends PureComponent {

  constructor(...args) {
    super(...args);
    this.state = {};
  }

  renderMonthlyPrice(cssProps) {
    const { tariff, inverted, ui } = this.props;
    return (
      <div
        className={suitcss({
          descendantName: 'priceMonthly',
          className: cssProps.classNames,
        }, this)}
      >
        <div
          className={suitcss({
            descendantName: 'unit',
          }, this)}
        >
          <Unit
            postfix={[
              getPaymentFeeDuration(tariff, ui, true),
              <FootnoteReference id={tariff.eid} />,
            ]}
            price={tariff.paymentFee}
            inverted={inverted}
            size="s"
            modifiers={[
              's',
              inverted && 'colorInverted',
            ]}
          />
        </div>
      </div>
    );
  }

  renderHeader() {
    const { moduleId, inverted, tariff, linkPrimary } = this.props;
    const { type, name } = tariff;
    const equalizerGroup = `${moduleId}-tariffItemCompactHeader`;
    return (
      <RouterLink
        className={suitcss({
          descendantName: 'header',
        }, this)}
        data-eq-group-l={equalizerGroup}
        data-eq-group-m={equalizerGroup}
        to={linkPrimary.to}
      >
        <div
          className={suitcss({
            descendantName: 'title',
          }, this)}
        >
          <div
            className={suitcss({
              descendantName: 'type',
            }, this)}
          >
            <Headline
              size="xs"
              embedded
              raw
              utilities={[inverted && 'colorInverted', 'weightNormal']}
            >
              {type}
            </Headline>
          </div>
          <div
            className={suitcss({
              descendantName: 'name',
            }, this)}
          >
            <Headline
              size="l"
              embedded
              raw
              utilities={[
                inverted && 'colorInverted',
                'weightBold',
                'colorPrimary',
                'hidden',
                'sBlock',
              ]}
            >
              {name}
            </Headline>
            <Headline
              size="m"
              embedded
              raw
              utilities={[
                inverted && 'colorInverted',
                'weightBold',
                'colorPrimary',
                'sHidden',
              ]}
            >
                {name}
              </Headline>
            </div>
        </div>
        {this.renderMonthlyPrice({ classNames: ['u-sBlock', 'u-mlHidden'] })}
      </RouterLink>
    );
  }

  renderContent() {
    const { headline, subline } = this.props.tariff;
    const { inverted } = this.props;
    return (
      <div
        className={suitcss({
          descendantName: 'text',
        }, this)}
      >
        <div
          className={suitcss({
            descendantName: 'headline',
          }, this)}
        >
          <Headline
            size="m"
            embedded
            raw
            utilities={[
              inverted && 'colorInverted',
              'weightNormal',
              'colorPrimary',
            ]}
          >
            {headline}
          </Headline>
        </div>
        {subline && (
          <div
            className={suitcss({
              descendantName: 'subline',
            }, this)}
          >
            <Headline
              size="m"
              embedded
              raw
              element="div"
              utilities={[
                inverted && 'colorInverted',
                'weightNormal',
              ]}
            >
              {subline}
            </Headline>
          </div>
        )}
      </div>
    );
  }

  renderSubcontent() {
    const { linkPrimary } = this.props;
    return (
      <div
        className={suitcss({
          descendantName: 'subcontent',
        }, this)}
      >
        {this.renderMonthlyPrice({ classNames: ['u-sHidden', 'u-mlBlock'] })}
        <div
          className={suitcss({
            descendantName: 'buttons',
          }, this)}
        >
          <div
            className={suitcss({
              descendantName: 'link',
            }, this)}
          >
            <Link
              to={linkPrimary.to}
              asButton
              buttonFilled
              buttonWithoutLabel
              utilities={['hidden', 'sInlineBlock']}
            >
              {linkPrimary.label}
            </Link>
            <Link
              to={linkPrimary.to}
              asButton
              buttonFilled
              utilities={['sHidden']}
            >
              {linkPrimary.label}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { inverted, tariff } = this.props;
    return (
      <section
        className={suitcss({}, this)}
        data-tracking="tariff"
        data-tariff-id={tariff.iid}
      >
        {this.renderHeader()}
        <div
          className={suitcss({
            descendantName: 'content',
          }, this)}
        >
          {this.renderContent()}
          <Callout
            theme="badge"
            targets={[tariff.eid]}
            inverted={inverted}
          />
        </div>
        {this.renderSubcontent()}
      </section>
    );
  }
}

TariffItemCompact.propTypes = {
  tariff: tariffShape.isRequired,
  inverted: PropTypes.bool,
  linkPrimary: PropTypes.shape({
    label: PropTypes.string,
    to: PropTypes.string,
  }).isRequired,
  ui: PropTypes.shape({}),
  moduleId: PropTypes.string,
  productInformationSheetLink: PropTypes.object.isRequired,
};

TariffItemCompact.defaultProps = {
  inverted: true,
};

export default connectUI()(TariffItemCompact);
